import React, { FunctionComponent } from 'react';

import { PartnerLogo } from 'src/components/partner-logo';
import { config } from 'src/config';
import { i18n } from 'src/i18n';
import { selectSelectedAccount } from 'src/state/account/selectors';
import { selectPartnerListIfDefined } from 'src/state/request/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { PartnerUtils } from 'src/utils/partner-utils';

import { FooterCustomerInformation } from './footer-customer-information';
import { FooterExternalLink } from './footer-external-link';
import { StyledFooter, StyledLinks, StyledLogoAndLinksContainer } from './footer.styled';

export const Footer: FunctionComponent = () => {
  const account = useAppSelector(selectSelectedAccount);
  const partnerList = useAppSelector(selectPartnerListIfDefined);
  const partner = account && partnerList && PartnerUtils.getPartnerByPartnerId(partnerList, account.partnerId);

  return (
    <StyledFooter>
      <FooterCustomerInformation />
      <StyledLogoAndLinksContainer>
        <PartnerLogo partner={partner} />
        <StyledLinks>
          <FooterExternalLink label={i18n.component.footer.linkToCustomerService} url={config.CUSTOMER_SERVICE_URL} />
          <FooterExternalLink label={i18n.component.footer.linkToMainPage} url={config.MAIN_PAGE_URL} />
          {partner?.siteUrl && <FooterExternalLink label={partner.name} url={partner.siteUrl} />}
        </StyledLinks>
      </StyledLogoAndLinksContainer>
    </StyledFooter>
  );
};
